import React from 'react'
import SchoolOutlined from '@mui/icons-material/SchoolOutlined'

export default function TrialBanner({ showJoinButton, onOpenCourseManagement }) {
  return (
    <div className="trial-banner">
      <div className="trial-banner-main">
        <SchoolOutlined className="trial-banner-icon" />
        <div>
          <p className="trial-banner-title">尚未加入课程 · 试用公开资源</p>
          <p className="trial-banner-desc">
            你可以先体验下方公开 / 官方训练。加入课程后，这里会显示教师为你编排的学习路径。
          </p>
        </div>
      </div>
      {showJoinButton ? (
        <button type="button" className="trial-banner-action" onClick={onOpenCourseManagement}>
          加入课程
        </button>
      ) : null}
    </div>
  )
}
